/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	class APISpec {
		// generate a list of action that will restore this union to its current stae
		serializeActions() {
			const actions = [];
			this.dataItemImplList.forEach(dataItemImpl => {
				const params = [];
				const resultActions = [];
				if (dataItemImpl){
					params.push({ columnId: dataItemImpl.getColumnId(), id: dataItemImpl.getId() });
					resultActions.push(dataItemImpl.serializeActions() );
				}
				actions.push({
					name: 'addDataItem',
					params: params,
					resultActions: resultActions
				});
			});
			return actions;
		}

		getAPISpec() {
			if (!this.apiSpec){

				this.apiSpec = {
					name:'union API',
					events:{
						propagationInfo: {
							callStack: {
								name: 'getUnion',
								params:[]
							}
						},
						actions: {
							addDataItem: {
								eventName:'addUnionDataItem',
								isResolvePostResponse: true,
								getInfo: (args) => {
									return {
										columnId: args[0],
										supportsUndoRedo: true,
										refresh: {
											data: true
										}
									};
								},
								getUndoActions: (args, returnValue) => {
									let dataItemId;
									if(returnValue) {
										dataItemId = returnValue.getId();
									}

									return [{
										name: 'removeDataItem',
										params: [dataItemId]
									}];
								}
							},
							removeDataItem: {
								eventName:'removeUnionDataItem',
								getInfo: (args) => {
									return {
										dataItemId: args[0],
										supportsUndoRedo: true,
										refresh: {
											data: true
										}
									};
								},
								getUndoActions: (args) => {
									const dataItemImpl= this.getDataItemImpl(args[0]);
									const params = [];
									const resultActions = [];
									if (dataItemImpl){
										params.push({ columnId: dataItemImpl.getColumnId(), id: dataItemImpl.getId() });
										resultActions.push(dataItemImpl.serializeActions() );
									}
									return [{
										name: 'addDataItem',
										params: params,
										resultActions: resultActions
									}];
								}
							}
						}
					}

				};
			}
			return this.apiSpec;

		}

	}

	return APISpec;
});
